import { Drawer } from '@mui/material'

const RightDrawer = ({ isOpen, onClose, children }) => {
  return (
    <div>
      <Drawer anchor='right' open={isOpen} onClose={onClose}>
        {children}
      </Drawer>
    </div>
  )
}

export default RightDrawer
